import { IComments } from 'interface/comment';
import { enTypeComment } from 'interface/lessonComment';
import { API_V4_BASE_URL } from 'settings';
import { toastError, toastSuccess } from 'utils/reduxToast';
import { del, get, post } from './api';

interface IParams {
  lessonId: number;
  type: enTypeComment;
  page?: number;
  order?: string;
}
export interface IDataWithPagination<T = IComments[]> {
  order: string;
  page: number;
  size: number;
  totalPages: number;
  data: T;
}

export const saveComment = (lessonId: number, text: string) => {
  return post({
    url: `/learner/lessons/${lessonId}/comments`,
    baseURL: API_V4_BASE_URL,
    data: { text },
  })
    .then((response) => response.data.data)
    .then((data) => {
      toastSuccess('Comentário feito com sucesso!');
      return data;
    })
    .catch(() => toastError('Ocorreu um erro ao enviar o comentário'));
};

export const saveCommentReply = (lessonId: number, parentId: number, text: string) => {
  return post({
    url: `/learner/lessons/${lessonId}/comments/${parentId}/reply`,
    baseURL: API_V4_BASE_URL,
    data: { text },
  })
    .then((response) => response.data.data)
    .then((data) => {
      toastSuccess('Comentário feito com sucesso!');
      return data;
    })
    .catch(() => toastError('Ocorreu um erro ao enviar o comentário'));
};

export const fetchComments = (params: Partial<IParams>): Promise<IDataWithPagination> => {
  const isOwnComment = params.type === enTypeComment.ownComment;
  return get({
    url: `/learner/lessons/${params.lessonId}/${params.type}`,
    params: {
      page: 1,
      order: 'DESC',
      ownComments: isOwnComment,
      ...params,
    },
    baseURL: API_V4_BASE_URL,
  })
    .then((response) => {
      return {
        data: response.data.data,
        ...response.data.page,
        totalPages: response.data.total_pages,
      };
    })
    .catch(() => toastError('Ocorreu um erro ao carregar os comentários'));
};

export const getReplies = (lessonId: number, type: enTypeComment, parentId: number) => {
  return get({
    url: `/learner/lessons/${lessonId}/${type}/${parentId}?order=ASC`,
    baseURL: API_V4_BASE_URL,
  })
    .then((response) => response.data.data)
    .catch(() => toastError('Ocorreu um erro ao trazer as respostas do comentário'));
};

export const deleteComment = (lessonId: number, commentId: number, isReply: boolean = false) => {
  return del({
    url: `/learner/lessons/${lessonId}/${isReply ? 'reply' : 'comments'}/${commentId}`,
    baseURL: API_V4_BASE_URL,
  })
    .then((response) => {
      toastSuccess('Comentário excluido com sucesso');
      return response.data.data;
    })
    .catch(() => {
      toastError('Ocorreu um erro ao excluir o comentário');
    });
};
